import { IMSObject, IMSId } from './ims-object';

/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190402 by Jan Brunner
 *     all rights reserved.
 */

export class Archive extends IMSObject {
  static fromDto(dto: ArchiveDTO, databag?: any) {
    const obj =  new this(
      {
        imsId: dto.id,
        secondaryId: dto.secondaryid,
        objRef: 'ims/Archive'
      },
      dto.label,
      dto.maxphotosize,
      dto.restricttoobjref,
      dto.onlytransmitviawlan
    );

    if (databag) {
      obj.databag = databag;
    } else {
      obj.databag = dto;
    }
    return obj;
  }

  constructor(
    public readonly id: IMSId,
    label: string,
    public maxPhotoSize: number,
    public restrictToObjRef: string,
    public onlyTransmitviaWlan: boolean
  ) {
    super(id.imsId, id.secondaryId, label, 'ims/Archive');
  }
}

export interface ArchiveDTO {
  id: number;
  secondaryid: number;
  label: string;
  maxphotosize: number;
  restricttoobjref: string;
  onlytransmitviawlan: boolean;
}
